module.exports = __webpack_public_path__ + "assets/img/ci-brightness.af5503d0.svg";